'use client';

import { useEffect } from 'react';
import { Alert02Icon, Home01Icon } from 'hugeicons-react';
import { Button } from '@/core/ui/primitives/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
  }, [error]);

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <Alert02Icon className="size-7 text-destructive" />
        </div>
        <h1 className="mb-2 text-lg font-semibold text-foreground">Something went wrong</h1>
        <p className="mb-6 max-w-sm text-sm text-muted-foreground">
          An unexpected error occurred. Please try again or return to the dashboard.
        </p>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="lg" onClick={reset}>
            Try again
          </Button>
          <Button size="lg" onClick={() => (window.location.href = '/dashboard')}>
            <Home01Icon data-icon="inline-start" />
            Dashboard
          </Button>
        </div>
        {error.digest && (
          <p className="mt-4 text-xs text-muted-foreground/60">Error ID: {error.digest}</p>
        )}
      </div>
    </main>
  );
}
